define(
    'viewmodels/secured/explorer/details/tabs/actions/CancelCheckoutAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "viewmodels/secured/explorer/details/documentClipboard",
        "services/config",
        "services/eventbroker",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, documentClipboard, config, eventBroker, dialogService, documentsService, i19n) {
        var CancelCheckoutAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.cancelcheckout,
                    message: i19n.to.cancelcheckout + "."
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-circle-o", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();
                var documentId = documents.length == 1 ? documents[0].documentId : null;
                var promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionCancelCheckOut", '');

                promise.then(function (dialogResult) {
                    if (dialogResult.cancelcheckout) {
                        documentsService.actions
                        .cancelCheckOutDocuments(documents)
                        .done(function () {
                            eventBroker.trigger(self, config.events.explorer.navigation.checkoutCount, null);
                        })
                        .fail(function (e) {
                            e.stopPropagation = true;

                            self.errors(e.error);

                            console.error(e);
                        })
                        .always(function () {
                            ctx.onReloadFolders({ documentId: documentId });

                            complete();
                        });
                    } else {
                        complete();
                    }
                });

                promise.then(complete);

                //documentsService.actions.canCancelCheckout(action.context.checkedDocuments())
                //.done(function (result) {
                //    var promise;

                //    if (!result.success) {
                //        promise = dialogService.showDocumentActionErrorDialog(result);
                //    } else {
                //        var documents = action.context.checkedDocuments();
                //        var documentId = documents.length == 1 ? documents[0].documentId : null;

                //        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionCancelCheckOut", '');
                           
                //        promise.then(function (dialogResult) {
                //            if (dialogResult.cancelcheckout) {                                   
                //                documentsService.actions
                //                .cancelCheckOutDocuments(documents)
                //                .done(function () {
                //                })
                //                .fail(function (e) {
                //                    e.stopPropagation = true;

                //                    self.errors(e.error);

                //                    console.warn(e);
                //                })
                //                .always(function () {                                        
                //                    ctx.onReloadFolders({ documentId: documentId });

                //                    complete();
                //                });
                //            } else {
                //                complete();
                //            }
                //        });
                //    }

                //    promise.then(complete);
                //});
            }

            return _Action;

        })(Action);

        return CancelCheckoutAction;
        
    });
